import type { ParseKeys } from 'i18next'

/* Which columns the Columns menu offers on the company-wide register of issued
 * paper (N-30, UX-DR-4). `number` is LOCKED for the reason every list locks its
 * identifier: a register with it turned off is a grid of anonymous rows. Kept
 * out of the component file, which may export only components. */
export const ISSUED_COLUMN_MENU: readonly { id: string; labelKey: ParseKeys; locked?: boolean }[] =
  [
    { id: 'number', labelKey: 'common.fields.number', locked: true },
    { id: 'counterparty', labelKey: 'finance.documents.raise.counterparty' },
    { id: 'case', labelKey: 'finance.documents.register.caseColumn' },
    { id: 'entity', labelKey: 'finance.documents.register.entityColumn' },
    { id: 'documentDate', labelKey: 'finance.documents.raise.noteDate' },
    { id: 'total', labelKey: 'common.fields.total' },
    { id: 'paid', labelKey: 'finance.documents.register.paidColumn' },
    { id: 'outstanding', labelKey: 'finance.documents.register.outstandingColumn' },
  ]

export const ISSUED_LOCKED_COLUMNS: readonly string[] = ISSUED_COLUMN_MENU.filter((entry) => entry.locked).map(
  (entry) => entry.id,
)
